<template>
  <div>
    <div class="d-flex flex-row">
      <div v-if="!mobile" class="flex-grow-1"></div>
      <div v-if="showBatchActions">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              small
              depressed
              color="white"
              :disabled="!approveActivateCondition || !access.approve"
              v-on="on"
              @click="batchApprovePDCs"
              >Approve
            </v-btn>
          </template>
          <p class="white--text">
            Approve multiple PDCs that are in pending approval state.
          </p>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              class="mx-1"
              small
              depressed
              color="white"
              :disabled="!approveActivateCondition || !access.reject"
              v-on="on"
              @click="batchRejectPDCs"
              >Reject
            </v-btn>
          </template>
          <p class="white--text">
            Reject multiple PDCs that are in pending approval state.
          </p>
        </v-tooltip>
      </div>
      <dots-menu :menu-items="menuItems"></dots-menu>
    </div>
    <v-card
      v-if="access.read"
      v-show="!loading"
      elevation="0"
      :class="{
        'card-container': true,
        'px-8': !mobile,
        'py-4': !mobile,
        'px-4': mobile
      }"
    >
      <v-data-table
        v-model="selected"
        class="denser"
        :search="searchString"
        :headers="headers"
        :items="postDatedChecks"
        :options.sync="options"
        :server-items-length="total"
        item-key="refNo"
        :loading="loading"
        loading-text="Loading... Please wait"
        no-data-text="All Post Dated Checks will appear here."
        multi-sort
        dense
        :show-select="showBatchActions"
        :footer-props="
          !mobile
            ? { 'items-per-page-options': [12, 24, 48, 96, 200] }
            : { 'items-per-page-options': [5] }
        "
      >
        <template v-slot:item="{ item, isSelected, select }">
          <tr v-if="!mobile" style="cursor: pointer" @click="showPreview(item)">
            <td v-if="showBatchActions">
              <v-checkbox
                v-model="isSelected"
                hide-details
                dense
                class="mt-0"
                @change="select"
                @click.stop
              ></v-checkbox>
            </td>
            <td>
              <p class="caption">{{ item.refNo }}</p>
            </td>
            <td v-if="type">
              <p class="caption">{{ item.paymentRefNo }}</p>
            </td>
            <td v-if="type">
              <p class="caption">{{ item.category }}</p>
            </td>
            <td>
              <p class="caption">{{ item.dateCreated }}</p>
            </td>
            <td v-if="type !== Types.UNIT">
              <a class="caption" @click.stop="redirectBed(item.bedId)">{{
                item.unitName
              }}</a>
            </td>
            <td
              v-if="type !== Types.UNIT && type !== Types.USER"
              class="text-overflow"
            >
              <p class="caption">{{ item.tenantName }}</p>
            </td>
            <td>
              <p class="caption">{{ item.checkNumber }}</p>
            </td>
            <td>
              <p class="caption">{{ formatCurrency(item.amount) }}</p>
            </td>
            <td>
              <p class="caption">{{ item.dueDate }}</p>
            </td>
            <td v-if="item.status == 'open' && checkDueDateIcon(item.dueDate)">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="d-flex flex-row" v-on="on">
                    <v-icon x-small color="red" class="mr-1"
                      >mdi-alert-circle</v-icon
                    >
                    <p class="caption red--text">
                      {{ getStatusText(item.status) }}
                    </p>
                  </div>
                </template>
                <p class="white--text">Check is due</p>
              </v-tooltip>
            </td>
            <td v-else-if="item.status == 'open'">
              <p class="caption red--text">
                {{ getStatusText(item.status) }}
              </p>
            </td>
            <td v-else>
              <p class="caption">{{ getStatusText(item.status) }}</p>
            </td>
            <td v-if="!showBatchActions">
              <div v-if="item.status">
                <div
                  v-if="item.status !== pdcStatus.PENDING_APPROVAL"
                  class="d-flex flex-row"
                >
                  <v-tooltip
                    v-if="item.status === pdcStatus.OPEN && access.update"
                    bottom
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        :disabled="!access.update"
                        @click.stop="update(item)"
                        v-on="on"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Update PDC</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="item.status === pdcStatus.OPEN && access.process"
                    bottom
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        :disabled="!access.process"
                        @click.stop="setProcessed(item)"
                        v-on="on"
                      >
                        <v-icon>mdi-import</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Processed</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      (item.status === pdcStatus.OPEN ||
                        item.status === pdcStatus.PROCESSED) &&
                      access.clear
                    "
                    bottom
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        :disabled="!access.clear"
                        @click.stop="setCleared(item)"
                        v-on="on"
                      >
                        <v-icon>mdi-check-decagram</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Cleared</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      (item.status === pdcStatus.OPEN ||
                        item.status === pdcStatus.PROCESSED) &&
                      access.not_clear
                    "
                    bottom
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="error"
                        x-small
                        :disabled="!access.not_clear"
                        @click.stop="setNotCleared(item)"
                        v-on="on"
                      >
                        <v-icon>mdi-alert-decagram</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Not Cleared</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      (item.status === pdcStatus.OPEN ||
                        item.status === pdcStatus.PROCESSED) &&
                      access.cancel
                    "
                    bottom
                    dark
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        x-small
                        :disabled="!access.cancel"
                        color="red"
                        v-on="on"
                        @click.stop="setCanceled(item)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Cancel</span>
                  </v-tooltip>
                  <action-button
                    :activate-condition="item.status === pdcStatus.CLEARED"
                    title="Cancel payment and revert PDC"
                    :action="() => cancelPaidPayment(item)"
                    icon="mdi-close"
                    color="error"
                  ></action-button>
                </div>
                <div v-else class="d-flex flex-row">
                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="primary"
                        x-small
                        :disabled="!access.approve"
                        @click.stop="approvePDC(item.pdcId)"
                        v-on="on"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Approve</span>
                  </v-tooltip>
                  <v-tooltip bottom dark>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        color="error"
                        x-small
                        :disabled="!access.reject"
                        @click.stop="rejectPDC(item.pdcId)"
                        v-on="on"
                      >
                        <v-icon>mdi-cancel</v-icon>
                      </v-btn>
                    </template>
                    <span style="color: white">Reject</span>
                  </v-tooltip>
                </div>
              </div>
            </td>
          </tr>
          <tr v-else @click="showPreview(item)">
            <!-- -PDC's mobile view -->
            <v-divider></v-divider>
            <div class="d-flex flex-column py-2">
              <div class="d-flex flex-row">
                <v-col class="pa-0">
                  <p class="font-weight-bold body-2">{{ item.tenantName }}</p>
                </v-col>
                <v-col class="pa-0" align="end">
                  <p class="font-weight-bold body-2">
                    {{ formatCurrency(item.amount) }}
                  </p>
                </v-col>
              </div>
              <div class="d-flex flex-row">
                <v-col class="pa-0 caption font-weight-bold">
                  Date Received
                </v-col>
                <v-col class="pa-0" align="end">
                  <p class="caption">{{ item.date }}</p>
                </v-col>
              </div>
              <div class="d-flex flex-row">
                <v-col class="pa-0 caption font-weight-bold">
                  Check date
                </v-col>
                <v-col class="pa-0" align="end">
                  <p class="caption">{{ item.dueDate }}</p>
                </v-col>
              </div>
              <div class="d-flex flex-row">
                <v-col class="pa-0 caption">
                  Check No. {{ item.checkNumber }}
                </v-col>
              </div>
              <div class="d-flex flex-row">
                <v-col class="pa-0 d-flex flex-row">
                  <p v-if="item.status == 'open'" class="caption">
                    Status:
                    <span class="red--text">{{
                      getStatusText(item.status)
                    }}</span>
                  </p>
                  <p v-else class="caption">
                    Status: {{ getStatusText(item.status) }}
                  </p>
                </v-col>
                <v-col class="pa-0" align="end">
                  <div v-if="item.status">
                    <div
                      v-if="item.status !== pdcStatus.PENDING_APPROVAL"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        v-if="item.status === pdcStatus.OPEN && access.update"
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="primary"
                            x-small
                            :disabled="!access.update"
                            @click.stop="update(item)"
                            v-on="on"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Update PDC</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="item.status === pdcStatus.OPEN && access.process"
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="primary"
                            x-small
                            :disabled="!access.process"
                            @click.stop="setProcessed(item)"
                            v-on="on"
                          >
                            <v-icon>mdi-import</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Processed</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          (item.status === pdcStatus.OPEN ||
                            item.status === pdcStatus.PROCESSED) &&
                          access.clear
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="primary"
                            x-small
                            :disabled="!access.clear"
                            @click.stop="setCleared(item)"
                            v-on="on"
                          >
                            <v-icon>mdi-check-decagram</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Cleared</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          (item.status === pdcStatus.OPEN ||
                            item.status === pdcStatus.PROCESSED) &&
                          access.not_clear
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="error"
                            x-small
                            :disabled="!access.not_clear"
                            @click.stop="setNotCleared(item)"
                            v-on="on"
                          >
                            <v-icon>mdi-alert-decagram</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Not Cleared</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="
                          (item.status === pdcStatus.OPEN ||
                            item.status === pdcStatus.PROCESSED) &&
                          access.cancel
                        "
                        bottom
                        dark
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            :disabled="!access.cancel"
                            color="red"
                            v-on="on"
                            @click.stop="setCanceled(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Cancel</span>
                      </v-tooltip>
                      <action-button
                        :activate-condition="item.status === pdcStatus.CLEARED"
                        title="Cancel payment and revert PDC"
                        :action="() => cancelPaidPayment(item)"
                        icon="mdi-close"
                        color="error"
                      ></action-button>
                    </div>
                    <div v-else class="d-flex justify-end">
                      <v-tooltip bottom dark>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="primary"
                            x-small
                            :disabled="!access.approve"
                            @click.stop="approvePDC(item.pdcId)"
                            v-on="on"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Approve</span>
                      </v-tooltip>
                      <v-tooltip bottom dark>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            color="error"
                            x-small
                            :disabled="!access.reject"
                            @click.stop="rejectPDC(item.pdcId)"
                            v-on="on"
                          >
                            <v-icon>mdi-cancel</v-icon>
                          </v-btn>
                        </template>
                        <span style="color: white">Reject</span>
                      </v-tooltip>
                    </div>
                  </div>
                </v-col>
              </div>
            </div>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-skeleton-loader
      v-show="loading"
      ref="skeleton"
      type="table"
      loading
      class="mx-auto"
    ></v-skeleton-loader>
    <SendMessageNotCleared ref="sendMessageNotCleared"></SendMessageNotCleared>
    <UpdatePDC ref="updatePDC"></UpdatePDC>
    <ProcessPDC ref="processPDC"></ProcessPDC>
    <CheckPreviewTemplate ref="previewTemplate"></CheckPreviewTemplate>
    <ConfirmWithDescription
      ref="confirmWithDescription"
    ></ConfirmWithDescription>
    <CancelPaidPayment ref="cancelPaidPayment"></CancelPaidPayment>
    <BatchApproveCreatePDCs
      ref="batchApproveCreatePDCs"
    ></BatchApproveCreatePDCs>
    <BatchRejectCreatePDCs ref="batchRejectCreatePDCs"></BatchRejectCreatePDCs>
  </div>
</template>

<script>
import { dayjs } from '../../util/date'
import CheckPreviewTemplate from '../../components/pdc/CheckPreviewTemplate.vue'
import SendMessageNotCleared from '../../components/pdc/SendMessageNotCleared.vue'
import ProcessPDC from '../../components/pdc/ProcessPDC.vue'
import UpdatePDC from '../../components/pdc/UpdatePDC.vue'
import Hashids from 'hashids'
import ConfirmWithDescription from '../../components/pdc/ConfirmWithDescription.vue'
import CancelPaidPayment from '../../components/payment/CancelPaidPayment.vue'
import { PDCStatus, PDCStatusSelect } from '../../config/pdc'
import ActionButton from '../ActionButton.vue'
import DotsMenu from '../../components/menu/DotsMenu.vue'
import BatchApproveCreatePDCs from '../../components/pdc/BatchApproveCreatePDCs.vue'
import BatchRejectCreatePDCs from '../../components/pdc/BatchRejectCreatePDCs.vue'
const hashids = new Hashids()

export default {
  components: {
    CheckPreviewTemplate,
    SendMessageNotCleared,
    ProcessPDC,
    UpdatePDC,
    ConfirmWithDescription,
    CancelPaidPayment,
    ActionButton,
    DotsMenu,
    BatchApproveCreatePDCs,
    BatchRejectCreatePDCs
  },
  props: [
    'searchString',
    'selectedStatuses',
    'searchTrigger',
    'leaseId',
    'tenantId',
    'type'
  ],
  data() {
    return {
      loading: false,
      limit: 0,
      total: 0,
      options: {},
      selectedItem: {},
      statuses: PDCStatusSelect,
      pdcStatus: PDCStatus,
      showBatchActions: false,
      Types: {
        UNIT: 'unit',
        USER: 'user'
      },
      selected: []
    }
  },
  computed: {
    access() {
      return this.$root.$roleAccess('pdc').access
    },
    postDatedChecks() {
      return this.$store.getters['pdcs/getPdcs']
    },
    headers() {
      let headers = this.$store.getters['pdcs/getHeaders']

      if (this.showBatchActions) {
        headers = headers.filter((h) => h.value !== 'actions')
      }

      switch (this.type) {
        case this.Types.UNIT:
          return headers.filter(
            (h) => !['unitName', 'tenantName'].includes(h.value)
          )
        case this.Types.USER:
          return headers.filter((h) => !['tenantName'].includes(h.value))
        default:
          return headers.filter(
            (h) => !['category', 'paymentRefNo'].includes(h.value)
          )
      }
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    menuItems() {
      return [
        {
          icon: 'mdi-pencil',
          title: 'Toggle batch actions',
          action: this.toggleBatchActions,
          disabled: null,
          message: 'Batch actions on PDCs'
        }
      ]
    },
    approveActivateCondition() {
      return (
        this.selected.length > 0 &&
        this.selected.every(
          (item) => item.status === PDCStatus.PENDING_APPROVAL
        )
      )
    }
  },
  watch: {
    options: {
      handler() {
        this.searchAction()
      }
    },
    searchTrigger: {
      async handler() {
        await this.searchAction()
      }
    }
  },
  methods: {
    async searchAction() {
      this.loading = true
      await this.$store
        .dispatch('pdcs/fetchPdcsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          search: this.searchString,
          status: this.selectedStatuses,
          leaseId: this.leaseId,
          tenantId: this.tenantId
          // categories: this.selectedCategories
        })
        .then((data) => {
          this.loading = false
          this.limit = data.limit
          this.total = data.count
        })
    },
    reload() {
      this.searchAction()
      this.$emit('PDCReload')
    },
    getStatusText(status) {
      const o = this.statuses.find((s) => {
        return s.value === status
      })

      return (o && o.text) || ''
    },
    async setProcessed(item) {
      const response = await this.$refs.confirmWithDescription.open({
        title: 'Update PDC',
        message: `Are you sure you want to set the post dated check #${item.refNo} as processed?`,
        description: item.description,
        currentAttachments: item.attachments
      })

      if (!response) return

      this.loading = true
      const processResponse = await this.$store.dispatch(
        'pdcs/setProcessedAction',
        {
          pdcId: item.pdcId,
          description: response.description,
          currentAttachments: response.currentAttachments,
          attachments: response.attachments
        }
      )

      if (processResponse) {
        this.$root
          .$confirm({
            title: 'Update PDC',
            message: `The PDC has been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.reload()
          })
      }
    },
    async setCleared(item) {
      const response = await this.$refs.confirmWithDescription.open({
        title: 'Update PDC',
        message: `Are you sure you want to set the post dated check #${item.refNo} as cleared? This will change the status of the associated payment to Paid.`,
        description: item.description,
        currentAttachments: item.attachments
      })

      if (!response) return

      this.loading = true
      const clearedResponse = await this.$store.dispatch(
        'pdcs/setClearedAction',
        {
          pdcId: item.pdcId,
          description: response.description,
          currentAttachments: response.currentAttachments,
          attachments: response.attachments
        }
      )

      if (clearedResponse) {
        this.$root
          .$confirm({
            title: 'Update PDC',
            message: `The PDC has been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.reload()
          })
      }
    },
    async setNotCleared(item) {
      const response = await this.$refs.confirmWithDescription.open({
        title: 'Update PDC',
        message: `Are you sure you want to set the post dated check #${item.refNo} as not cleared? This will change the status of the associated payment to Pending.`,
        description: item.description,
        currentAttachments: item.attachments
      })

      if (!response) return

      const confirm = await this.$root.$confirm({
        title: 'Send Message to Tenant',
        message:
          'Would you like to send a message to the tenant to notify that their check has not cleared?',
        showDeny: true
      })
      if (confirm === true) {
        this.loading = true
        if (
          !(await this.$refs.sendMessageNotCleared.open({
            tenantId: item.tenantId,
            dueDate: item.dueDate
          }))
        ) {
          this.loading = false
          return
        }

        const notClearedResponse = await this.$store.dispatch(
          'pdcs/setNotClearedAction',
          {
            pdcId: item.pdcId,
            description: response.description,
            currentAttachments: response.currentAttachments,
            attachments: response.attachments
          }
        )

        if (notClearedResponse) {
          this.$root
            .$confirm({
              title: 'Update PDC',
              message: `The PDC has been updated.`,
              reconfirmOnly: true,
              confirmText: 'OK'
            })
            .then(() => {
              this.loading = false
              this.reload()
            })
        }
      } else if (confirm === 'deny') {
        this.loading = true
        const notClearedResponse = await this.$store.dispatch(
          'pdcs/setNotClearedAction',
          {
            pdcId: item.pdcId,
            description: response.description,
            currentAttachments: response.currentAttachments,
            attachments: response.attachments
          }
        )
        if (notClearedResponse) {
          this.$root
            .$confirm({
              title: 'Update PDC',
              message: `The PDC has been updated.`,
              reconfirmOnly: true,
              confirmText: 'OK'
            })
            .then(() => {
              this.loading = false
              this.reload()
            })
        }
      }
    },
    async setCanceled(item) {
      const response = await this.$refs.confirmWithDescription.open({
        title: 'Update PDC',
        message: `Are you sure you want to set the post dated check #${item.refNo} as canceled? This will change the status of the associated payment to Canceled.`,
        description: item.description,
        currentAttachments: item.attachments
      })

      if (!response) return

      this.loading = true
      const canceledResponse = await this.$store.dispatch(
        'pdcs/setCanceledAction',
        {
          pdcId: item.pdcId,
          description: response.description,
          currentAttachments: response.currentAttachments,
          attachments: response.attachments
        }
      )

      if (canceledResponse) {
        this.$root
          .$confirm({
            title: 'Update PDC',
            message: `The PDC has been updated.`,
            reconfirmOnly: true,
            confirmText: 'OK'
          })
          .then(() => {
            this.loading = false
            this.reload()
          })
      }
    },
    redirectBed(bedId) {
      if (bedId) this.$router.push(`/bed/${hashids.encode(bedId)}`)
    },
    checkDueDateIcon(date) {
      return !dayjs(date).isAfter(
        dayjs().hour(0).minute(0).second(0).millisecond(0),
        'day'
      )
    },
    showPreview(item) {
      this.selectedItem = item
      this.$refs.previewTemplate.open({ item: item })
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    update(item) {
      this.$refs.updatePDC.open({ item: item }).then((success) => {
        if (success) {
          this.reload()
        }
      })
    },
    approvePDC(pdcId) {
      this.$root
        .$confirm({
          title: 'Approve PDC',
          message: 'Are you sure you want to approve the PDC?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('pdcs/approvePDCAction', { pdcId })
            await this.reload()
          }
        })
    },
    rejectPDC(pdcId) {
      this.$root
        .$confirm({
          title: 'Reject PDC',
          message: 'Are you sure you want to reject the PDC?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('pdcs/rejectPDCAction', { pdcId })
            await this.reload()
          }
        })
    },
    cancelPaidPayment(item) {
      const paymentDetails = item.payment_details
      if (!paymentDetails) {
        this.$root.$snack('There was an error cancelling the payment')
        return
      }

      const paidPaymentId = paymentDetails.paidItems[0].paidPaymentId
      const amountPaid = paymentDetails.paidItems[0].amount
      const payment = {
        ...item.payment_details,
        tenantName: item.tenantName,
        total: amountPaid,
        paidPaymentId
      }
      this.$refs.cancelPaidPayment.open(payment).then(() => {
        this.reload()
      })
    },
    toggleBatchActions() {
      this.showBatchActions = !this.showBatchActions
    },
    batchApprovePDCs() {
      this.$refs.batchApproveCreatePDCs
        .open({ pdcs: this.selected })
        .then(() => {
          this.resetSelected()
          this.reload()
        })
    },
    batchRejectPDCs() {
      this.$refs.batchRejectCreatePDCs
        .open({ pdcs: this.selected })
        .then(() => {
          this.resetSelected()
          this.reload()
        })
    },
    resetSelected() {
      this.selected = []
    }
  }
}
</script>

<style scoped>
.card-container {
  border-radius: 12px !important;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;*/
  border-color: #eeeeee !important;
}
.text-overflow {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
